import { EventInfoWithConsentResponse } from '@ent-regis/entregis-ts-angular/model/eventInfoWithConsentResponse';

// "Types of Institutional Investors" is shown either when the admin has enabled the
// "Invited by" sale person tab for the event, or unconditionally for Digital Roadshow
// events (ENTND-27510: Digital Roadshow must always collect this field).
export function shouldShowInstitutionalInvestorType(
  eventInfoWithConsent: EventInfoWithConsentResponse | null | undefined
): boolean {
  return !!eventInfoWithConsent && (
    !!eventInfoWithConsent.isShowSalePersonForInvestorRegistration
    || eventInfoWithConsent.eventType === EventInfoWithConsentResponse.EventTypeEnum.DIGITALROADSHOW
  );
}
